import * as React from 'react';
import { NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

export default class MenuLink extends React.Component {
  static propTypes = {
    children: React.PropTypes.oneOfType([
      React.PropTypes.element,
      React.PropTypes.string
    ]).isRequired
  }

  render() {
    return (
      <LinkContainer {...this.props}>
        <NavItem>{this.props.children}</NavItem>
      </LinkContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/components/menu/menu_link.jsx